import { useId } from "react";
import { ChevronDown } from "lucide-react";

export default function AccordionCard({ title, subtitle, icon, badge, actions, leadingContent, compact = false, expanded, onToggle, children }) {
  const contentId = useId();
  return (
    <section className={`${compact ? "border-b last:border-b-0" : "rounded-xl border"} border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900`}>
      <div className={`flex items-center gap-2 ${compact ? "px-3 py-2" : "p-3"}`}>
        {leadingContent}
        <button
          type="button"
          onClick={onToggle}
          aria-expanded={expanded}
          aria-controls={contentId}
          className="flex min-w-0 flex-1 items-center gap-3 rounded-lg p-1 text-left focus-visible:outline-secondary"
        >
          {icon && <span className="shrink-0 text-secondary">{icon}</span>}
          <span className="min-w-0 flex-1">
            <span className={`block text-gray-900 dark:text-gray-100 ${compact ? "text-xs font-medium" : "text-sm font-semibold"}`}>{title}</span>
            {subtitle && <span className="mt-1 block text-xs text-gray-500 dark:text-gray-400">{subtitle}</span>}
          </span>
          {badge}
          <ChevronDown size={16} className={`shrink-0 text-gray-400 transition-transform ${expanded ? "rotate-180" : ""}`} />
        </button>
        {actions}
      </div>
      <div id={contentId} hidden={!expanded} className="border-t border-gray-200 p-4 dark:border-gray-800">
        {expanded && children}
      </div>
    </section>
  );
}
